// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1kzBr","requiredAsterisk":"Info_requiredAsterisk__1M6EH"};